export enum OptionalInvoiceExportField {
	CLIENT_ADDRESS = 'CLIENT_ADDRESS',
	COMPANY_ADDRESS = 'COMPANY_ADDRESS',
	COMPANY_VAT = 'COMPANY_VAT',
	COMPANY_LOGO = 'COMPANY_LOGO',
	INVOICE_ID = 'INVOICE_ID',
	INVOICE_REFERENCE = 'INVOICE_REFERENCE',
	INVOICE_NOTES = 'INVOICE_NOTES',
	INVOICE_NAME = 'INVOICE_NAME',
	CONTACT_NAME = 'CONTACT_NAME',
	TIME_REGISTRATIONS = 'TIME_REGISTRATIONS',
}

export type OptionalInvoiceExportFieldStates = {
	clientAddressChecked: boolean;
	companyAddressChecked: boolean;
	companyVatChecked: boolean;
	companyLogoChecked: boolean;
	invoiceIdChecked: boolean;
	invoiceReferenceChecked: boolean;
	invoiceNotesChecked: boolean;
	invoiceNameChecked: boolean;
	contactNameChecked: boolean;
	timeRegistrationsChecked: boolean;
};
